import React from 'react';

export const path =
  'M9,5 L9,8.5 C9,8.77614237 8.77614237,9 8.5,9 L5.5,9 C5.22385763,9 5,8.77614237 5,8.5 L5,5 L3,5 L7,1 L11,5 L9,5 Z M11,11 L11,9.5 C11,9.22385763 11.2238576,9 11.5,9 L12.5,9 C12.7761424,9 13,9.22385763 13,9.5 L13,11.5 L13,12.5 C13,12.7761424 12.7761424,13 12.5,13 L1.5,13 C1.22385763,13 1,12.7761424 1,12.5 L1,11.5 L1,9.5 C1,9.22385763 1.22385763,9 1.5,9 L2.5,9 C2.77614237,9 3,9.22385763 3,9.5 L3,11 L11,11 Z';

export default class Upload extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <path d={path} className="fill-current" />
      </g>
    );
  }
}
